import { cn } from '@/lib/utils'
import { Reveal } from '@/components/generals/reveal'
import { Marquee } from '@/components/generals/marquee'

import {
    ClientLogoOne,
    ClientLogoTwo,
    ClientLogoThree,
    ClientLogoFour,
    ClientLogoFive,
    ClientLogoSix
} from '@/components/generals/logos'

const logos = [
    ClientLogoOne,
    ClientLogoTwo,
    ClientLogoThree,
    ClientLogoFour,
    ClientLogoFive,
    ClientLogoSix
]

type LogoStripProps = {
    label?: string
    className?: string
    /** Play on mount rather than on scroll, for above-the-fold use. */
    immediate?: boolean
    delay?: number
}

/**
 * Its own section in the original, sitting directly below the hero with a wide
 * black box-shadow that feathers the hero's clipped glow into the page.
 */
export const LogoStrip = ({
    label = 'You’re in good hands:',
    className,
    immediate = false,
    delay = 0
}: LogoStripProps) => {
    return (
        <section
            className={cn(
                'relative z-1 w-full bg-black py-10 shadow-[0_0_32px_48px_#000]',
                className
            )}
        >
            <Reveal
                immediate={immediate}
                delay={delay}
                y={0}
                blur={0}
                duration={1}
                className='flex w-full flex-col items-center gap-12'
            >
                <p className='text-center text-base leading-none font-medium tracking-[-0.02em] text-white/56'>
                    {label}
                </p>

                <Marquee
                    duration={70}
                    gap='64px'
                    className='marquee-mask-wide'
                    fade={false}
                >
                    {[...logos, ...logos].map((Logo, index) => (
                        <Logo
                            key={index}
                            aria-hidden='true'
                            className='h-7 w-auto shrink-0 text-white/40 transition-colors duration-500 ease-[cubic-bezier(0.44,0,0.56,1)] hover:text-white/80 md:h-8'
                        />
                    ))}
                </Marquee>
            </Reveal>
        </section>
    )
}
